import { computed, ExtractPropTypes, toRefs, useListeners } from 'vue';
import vuetify from '@/plugins/vuetify';

export const props = {
  color: {
    type: String,
    default: 'primary',
  },
  width: {
    type: [String, Number],
    default: 20,
  },
  height: {
    type: [String, Number],
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  disabledColor: {
    type: String,
    default: 'waterloo',
  },
};

export const useIcon = (iconProps: ExtractPropTypes<typeof props>) => {
  const listeners = useListeners();

  const { color, width, height, disabled } = toRefs(iconProps);

  const isFillColor = computed(() => computedColor.value.startsWith('fill-'));
  const isStrokeColor = computed(() => computedColor.value.startsWith('stroke-'));
  const isTailwindColor = computed(() => isStrokeColor.value || isFillColor.value);
  const colorAttrsKey = computed(() => (isStrokeColor.value ? 'stroke' : 'fill'));

  const computedColor = computed<string>(() => {
    if (disabled?.value)
      return (vuetify.framework.theme.themes.light[iconProps.disabledColor] ??
        iconProps.disabledColor) as string;

    return (vuetify.framework.theme.themes.light[color?.value] ?? color?.value) as string;
  });

  const computedHeight = computed(() => {
    return height?.value || width?.value;
  });

  const iconClasses = computed(() => ({
    'cursor-pointer': !!listeners.click,
  }));

  const attrs = computed(() => ({
    width: width?.value,
    height: computedHeight.value,
    class: iconClasses.value,
  }));

  const pathAttrs = computed(() => ({
    ...(isTailwindColor.value
      ? { class: computedColor.value }
      : { [colorAttrsKey.value]: computedColor.value }),
  }));

  return { computedColor, attrs, pathAttrs };
};
